import { Form } from 'factorial-form'
import _ from 'lodash'

class ObservationForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      id: 'number',
      observation_text: 'string',
      effective_on: 'date',
      employee_id: 'number',
      payroll_policy_period_id: 'number',
    })
  }

  get handoffData() {
    const data = this.data()

    const attrs = _.pick(data, [
      'observation_text',
      'id',
      'employee_id',
      'payroll_policy_period_id',
    ])

    return { ...attrs }
  }
}

export default ObservationForm
